import { useMemo } from 'react';
import { CustomVizHookStatus } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const usePromotionCopilotCanAnalyze = ({
  status,
  selectedDepartments,
  selectedRoles,
  selectedLocations,
}: {
  status: CustomVizHookStatus;
  selectedDepartments: string[];
  selectedRoles: string[];
  selectedLocations: string[];
}) => {
  return useMemo(() => {
    return (
      status === 'waiting-for-user' &&
      selectedDepartments.length !== 0 &&
      selectedRoles.length !== 0 &&
      selectedLocations.length !== 0
    );
  }, [
    selectedDepartments.length,
    selectedLocations.length,
    selectedRoles.length,
    status,
  ]);
};
